import { useEffect } from 'react';

const STYLE_ID = 'vantage-reveal-animations';

const REVEAL_CSS = `
/* ── Scroll-reveal animations ──
 * Elements start visible (SSG-safe). JS adds .reveal--hidden on mount,
 * then IntersectionObserver swaps to .reveal--visible on scroll.
 */

.reveal-fade-up.reveal--hidden {
  opacity: 0;
  transform: translateY(24px);
}
.reveal-fade-up.reveal--visible {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),
              transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.reveal-scale.reveal--hidden {
  opacity: 0;
  transform: scale(0.92);
}
.reveal-scale.reveal--visible {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),
              transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.reveal-fade-in.reveal--hidden {
  opacity: 0;
}
.reveal-fade-in.reveal--visible {
  opacity: 1;
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

@media (prefers-reduced-motion: reduce) {
  .reveal-fade-up.reveal--hidden,
  .reveal-scale.reveal--hidden,
  .reveal-fade-in.reveal--hidden {
    opacity: 1;
    transform: none;
  }
}
`;

/**
 * Injects reveal animation CSS into <head> exactly once.
 * Call from any component that uses reveal classes.
 */
export function useRevealStyles(): void {
  useEffect(() => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = REVEAL_CSS;
    document.head.appendChild(style);
  }, []);
}
